// extracted by mini-css-extract-plugin
export default {"inner":"Sidebar_inner__APRdj","logo":"Sidebar_logo__yYIKi"};